import { useState, useRef, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { pages } from "../utils/constants";

function SearchBar() {
  const [inputText, setInputText] = useState("");
  const [show, setShow] = useState(false);
  const [activeIndex, setActiveIndex] = useState(-1);
  const wrapperRef = useRef(null);
  const navigate = useNavigate();

  const filtered = inputText.trim()
    ? pages.filter((page) =>
        page.name.toLowerCase().includes(inputText.toLowerCase())
      )
    : [];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setShow(false);
        setActiveIndex(-1);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleInput = (e) => {
    setInputText(e.target.value);
    setShow(true);
    setActiveIndex(-1);
  };

  const handleKeyDown = (e) => {
    if (!show || filtered.length === 0) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIndex((prev) => (prev + 1) % filtered.length);
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((prev) => (prev - 1 + filtered.length) % filtered.length);
    } else if (e.key === "Enter" && activeIndex >= 0) {
      navigate(filtered[activeIndex].path);
      setInputText("");
      setShow(false);
    } else if (e.key === "Escape") {
      setShow(false);
      setActiveIndex(-1);
    }
  };

  const handleSelect = (path) => {
    setInputText("");
    setShow(false);
    navigate(path);
  };

  return (
    <div className="main" ref={wrapperRef}>
      <div className="search">
        <input
          type="text"
          id="outlined-basic"
          value={inputText}
          onChange={handleInput}
          onKeyDown={handleKeyDown}
          onFocus={() => inputText && setShow(true)}
          placeholder="Search pages..."
          autoComplete="off"
        />
        {inputText && (
          <button
            className="clear-btn"
            onClick={() => {
              setInputText("");
              setShow(false);
            }}
          >
            ✕
          </button>
        )}
      </div>

      {show && filtered.length > 0 && (
        <ul className="searchResult">
          {filtered.map((page, index) => (
            <li
              key={page.path}
              onMouseEnter={() => setActiveIndex(index)}
              onClick={() => handleSelect(page.path)}
            >
              <Link to={page.path} onClick={(e) => e.preventDefault()} className="nav-link fontSizeClass itemHover">
                {page.name}
              </Link>
            </li>
          ))}
        </ul>
      )}

      {show && inputText.trim() && filtered.length === 0 && (
        <div className="searchResult no-result">No pages found.</div>
      )}
    </div>
  );
}

export default SearchBar;
